<template>
    <div class="container">

        <template v-if="!loading && recipe">

            <recipe-content :recipe='recipe'></recipe-content>

        </template>

        <template v-if="loading">

           <loading-spin :height='300' v-if="loading"></loading-spin>

        </template>

    </div>

</template>

<script>
import { RecipeApi } from '../api/RecipeApi'
import RecipeContent from './RecipeContent'
import { Recipe } from '../core/Recipe'

export default {
	components: {
		'recipe-content': RecipeContent
	},

	data () {
		return {
			loading: true,
			recipeId: null,
			recipe: null
		}
	},

	computed: {
		user () {
			return this.$root.user
		}
	},

	mounted () {
		if(!this.user || this.user.email.includes('guest.quomi.it') || this.user.isNew()) {
			window.dispatchEvent(new CustomEvent('openRecipeCoupon', {bubbles: true}))   
		}
 		
		this.recipeId = this.$route.params.id

		var rm = new RecipeApi()
		rm.recipe(this.recipeId).then(response => {
			this.recipe = new Recipe(response.body.data.resource)
			this.loading = false
		}).catch(response => {
			this.$router.push({ name: 'cookbook' })
		})
	}
}

</script>

<style scoped>

@media (max-width: 1024px) {
	.container {
		padding-top: 50px;
	}
}

</style>
